export default __webpack_public_path__ + "static/media/2476.a7131ae2.png";